"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var BlockLabel_1 = require("../../v2/components/BlockLabel");
var useScreenWidth_1 = require("../../utils/customHooks/useScreenWidth");
var _EXPORTS_1 = require("../../utils/_EXPORTS");
var Typo_1 = require("../Typo");
var buildCalenderObj_1 = require("./utils/buildCalenderObj");
var handlePos_1 = require("./utils/handlePos");
var themes_1 = require("../../themes");
var styled_1 = require("./styled");
var Buttons_1 = require("../Buttons");
var mixins_1 = require("../../themes/mixins");
var Modal_1 = require("../Modals/Modal");
var white = themes_1.colors.white, greyColor40 = themes_1.colors.greyColor40;
var months = [
    "January",
    "Febuary",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
];
var weeks = ["S", "M", "T", "W", "Th", "F", "Sa"];
var flag = true;
// note -> doesn't check time
var isEqualDate = function (date1, date2) {
    return date1.getDate() === date2.getDate() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getFullYear() === date2.getFullYear();
};
function DatePicker(props) {
    var value = props.value, onParentChange = props.onChange, id = props.id, from = props.from, readOnly = props.readOnly, previousDateOnly = props.previousDateOnly, futureDateOnly = props.futureDateOnly, invert = props.invert, disabled = props.disabled, debug = props.debug;
    var screenWidth = (0, useScreenWidth_1.useScreenWidth)();
    var inputRef = (0, react_1.useRef)(null);
    var calenderRef = (0, react_1.useRef)(null);
    var containerRef = (0, react_1.useRef)(null);
    var _a = (0, react_1.useState)({}), calender = _a[0], setCalender = _a[1];
    var _b = (0, react_1.useState)(false), showCalendar = _b[0], setShowCalendar = _b[1];
    var _c = (0, react_1.useState)(null), range = _c[0], setRange = _c[1];
    var _d = (0, react_1.useState)(0), monthNumber = _d[0], setMonthNumber = _d[1];
    // handle click outside should only work when calender container is not shown in modal.
    (0, _EXPORTS_1.useHandleClickOutside)(containerRef, setShowCalendar, { enabled: screenWidth > (0, mixins_1.getBreakPoint)('sm') });
    var debounce = function (dy, delay) {
        clearTimeout(dy._tId);
        dy._tId = setTimeout(function () {
            dy();
        }, delay);
    };
    (0, react_1.useEffect)(function () {
        // Check if the component is in 'readOnly' mode. If so, no further action is needed, so return early.
        if (readOnly)
            return;
        // Define a debounced version of the 'handleVerticalPos' function.
        // The debounced function will be called after 500 milliseconds of inactivity,
        // ensuring that the function is not invoked too frequently during continuous scroll events.
        var handleVerticalPosDebounced = debounce(function () {
            // Call the 'handleVerticalPos' function passing 'calenderRef' and 'inputRef' as arguments.
            // This function will be invoked when the user scrolls vertically on the page.
            // The 'handleVerticalPos' function is responsible for positioning the calendar container
            // relative to the input field, so that it remains visible even when the user scrolls the page.
            (0, handlePos_1.handleVerticalPos)(calenderRef, inputRef);
        }, 500);
        // Add an event listener to the 'scroll' event on the 'window'.
        // When the user scrolls the page, the 'handleVerticalPosDebounced' function will be called.
        window.addEventListener("scroll", handleVerticalPosDebounced);
        return function () {
            window.removeEventListener("scroll", handleVerticalPosDebounced);
        };
    }, []);
    (0, react_1.useEffect)(function () {
        if (readOnly)
            return;
        debounce(function () {
            (0, handlePos_1.handleHorizontalPos)(calenderRef, id);
        }, 500);
    }, [screenWidth]);
    var isValidDateInput = function (value) {
        if (!value)
            return false;
        var _a = value.split("/"), day = _a[0], month = _a[1], year = _a[2];
        // Check if we have all parts
        if (!day || !month || !year)
            return false;
        var dateObj = new Date(year, month - 1, day);
        return !isNaN(dateObj.getTime()) &&
            dateObj.getDate() === parseInt(day) &&
            dateObj.getMonth() === parseInt(month) - 1 &&
            dateObj.getFullYear() === parseInt(year);
    };
    (0, react_1.useEffect)(function () {
        // buildDateinput return date string in dd/mm/yyyy format if you pass date object
        if (readOnly)
            return;
        if (!isValidDateInput(inputRef.current.value)) {
            if (value) {
                inputRef.current.value =
                    value === "Ongoing" ? value : buildDateInput(new Date(value));
            }
            else {
                inputRef.current.value = "";
                setRange(null);
            }
        }
        if (from) {
            setRange(new Date(calender.year, calender.month, calender.today));
        }
        (0, buildCalenderObj_1.buildCalenderObj)(from, inputRef, monthNumber, calender, setCalender);
    }, [from, showCalendar]);
    (0, react_1.useEffect)(function () {
        if (readOnly)
            return;
        if (!value) {
            inputRef.current.value = "";
            (0, buildCalenderObj_1.buildCalenderObj)(from, inputRef, monthNumber, calender, setCalender);
        }
        else if (value !== "Ongoing") {
            inputRef.current.value = buildDateInput(new Date(value));
        }
    }, [value]);
    // handle on change month
    var handleChangeMonth = function (e, month) {
        console.log('change month fired');
        e.preventDefault();
        monthNumber += month;
        setMonthNumber(monthNumber < 0 ? 0 : monthNumber); // if
        (0, buildCalenderObj_1.buildCalenderObj)(from, inputRef, monthNumber, calender, setCalender);
    };
    var handleDayClick = function (e, item) {
        console.log('day click fired');
        var clickedDate = item;
        inputRef.current.value = buildDateInput(clickedDate);
        monthNumber = 0;
        setMonthNumber(monthNumber);
        (0, buildCalenderObj_1.buildCalenderObj)(from, inputRef, monthNumber, calender, setCalender);
        if (from) {
            setRange(item);
        }
        onParentChange(id, item.toISOString(), props.passChangeHandlerOps && props);
        setShowCalendar(false);
    };
    // returns date string in dd/mm/yyyy
    var buildDateInput = function (dateObj) {
        if (!dateObj)
            return "";
        var options = {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
        };
        return dateObj.toLocaleDateString("en-GB", options);
    };
    var autoFormatter = function () {
        var _a;
        var input = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.value;
        if (/^\d{2}\/?$/.test(input) && flag) {
            input += "/";
        }
        else if (/^\d{2}\/\d{2}$/.test(input) && flag) {
            input += "/";
        }
        inputRef.current.value = input;
    };
    var handleFocusOut = function () {
        var _a;
        console.log('focus out fired');
        console.log({ from: from });
        if (from && ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.value.split("/")[1]) == calender.month + 1) {
            setRange(new Date(calender.year, calender.month, calender.today));
        }
        monthNumber = 0;
        setMonthNumber(monthNumber);
        var dateObj = (0, buildCalenderObj_1.buildCalenderObj)(from, inputRef, monthNumber, calender, setCalender);
        if (from && dateObj < from) {
            dateObj = from;
        }
        inputRef.current.value = buildDateInput(dateObj);
        console.log({ dateObj: dateObj, inpuRefVal: inputRef.current.value });
        onParentChange(id, dateObj.toISOString(), props.passChangeHandlerOps && props);
    };
    var handleOnChange = function () {
        console.log('input onchange fired');
        autoFormatter();
        setMonthNumber(0);
        var dateObj = (0, buildCalenderObj_1.buildCalenderObj)(from, inputRef, monthNumber, calender, setCalender);
        if (from) {
            setRange(dateObj);
        }
    };
    var handleKeyDown = function (e) {
        console.log('key down fired');
        if (e.keyCode === 8) {
            flag = false;
        }
        else {
            flag = true;
        }
    };
    var handlePointerEnter = function (item) {
        console.log('pointer enter fired');
        setRange(item);
    };
    var wrapCaretLeft = react_1.default.useCallback(function () {
        return (react_1.default.createElement(Buttons_1.ButtonGhost, { S: true, invert: invert, icon: "CaretLeft", onMouseDown: function (e) { return handleChangeMonth(e, -1); }, style: { cursor: "pointer", color: invert && white } }));
    }, [value, invert]);
    var wrapCaretRight = react_1.default.useCallback(function () {
        return (react_1.default.createElement(Buttons_1.ButtonGhost, { S: true, invert: invert, icon: "CaretRight", onMouseDown: function (e) { return handleChangeMonth(e, 1); }, style: { cursor: "pointer", color: invert && white } }));
    }, [value, invert]);
    var getReadOnlyDate = function () {
        var dateObj = new Date(value);
        if (isNaN(dateObj.getDate()))
            return value; // this means that the value is 'Presently Ongoing'
        return "".concat(dateObj.getDate(), " ").concat(months[dateObj.getMonth()].substring(0, 3), " ").concat(dateObj.getFullYear());
    };
    var isSelectedDate = function (item) {
        var _a, _b, _c;
        return item
            ? ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.value.split("/")[0]) == item.getDate() &&
                ((_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.value.split("/")[1]) - 1 === item.getMonth() &&
                ((_c = inputRef.current) === null || _c === void 0 ? void 0 : _c.value.split("/")[2]) == item.getFullYear()
            : false;
    };
    var isTodaysDate = function (item) {
        return item.getDate() === new Date().getDate() &&
            item.getMonth() === new Date().getMonth() &&
            item.getFullYear() === new Date().getFullYear();
    };
    var isDisabledDate = function (item) {
        return (previousDateOnly && new Date() < item) ||
            (futureDateOnly && new Date() > item);
    };
    var genCalenderContainer = function () {
        var _a, _b, _c;
        return (react_1.default.createElement(styled_1.StyledCalenderContainer, { debug: debug, showCalendar: showCalendar, ref: calenderRef, className: " ".concat(from ? "right-class" : ""), invert: invert },
            react_1.default.createElement(styled_1.StyledMonthView, null,
                react_1.default.createElement(styled_1.StyledHeader, null,
                    wrapCaretLeft(),
                    react_1.default.createElement(styled_1.StyledMonthTitle, { invert: invert },
                        react_1.default.createElement("span", null,
                            react_1.default.createElement(Typo_1.SANS_3, { semibold: true }, months[calender === null || calender === void 0 ? void 0 : calender.month])),
                        react_1.default.createElement("span", null,
                            react_1.default.createElement(Typo_1.SANS_3, { semibold: true }, calender === null || calender === void 0 ? void 0 : calender.year))),
                    wrapCaretRight()),
                react_1.default.createElement(styled_1.StyledWeekDaysWrapper, null, weeks.map(function (item, i) { return (react_1.default.createElement(styled_1.StyledWeekdays, { key: i, invert: invert },
                    react_1.default.createElement(Typo_1.SANS_3, null, item))); })),
                react_1.default.createElement(styled_1.StyledBodyWrapper, { invert: invert }, (_a = calender === null || calender === void 0 ? void 0 : calender.prevDays) === null || _a === void 0 ? void 0 :
                    _a.map(function (item, i) {
                        if (from) {
                            if (item < range && item > from) {
                                // Render the day as part of the selected range (when 'from' and 'range' are defined)
                                return (react_1.default.createElement(styled_1.StyledDateBlock, { range: true, key: i, invert: invert, onMouseDown: function (e) { return handleDayClick(e, item); }, onPointerEnter: function () { return handlePointerEnter(item); }, disableClick: isDisabledDate(item) },
                                    react_1.default.createElement(Typo_1.SANS_3, null, item.getDate())));
                            }
                            else if (item < from) {
                                // Render disabled days before 'from' previous date (last month)
                                return (react_1.default.createElement(styled_1.StyledDateBlock, { isDisabledDate: true, key: i, invert: invert, disableClick: isDisabledDate(item), calenderRef: calenderRef },
                                    react_1.default.createElement(Typo_1.SANS_3, null, item.getDate())));
                            }
                            else {
                                // Render days in the previous month
                                // Check if the current day is 'today' or falls in the range of previousDateOnly or futureDateOnly
                                // and apply appropriate class name for styling
                                return (react_1.default.createElement(styled_1.StyledDateBlock, { key: i, invert: invert, isSelectedDate: isSelectedDate(item) || isEqualDate(from, item), isDisabledDate: isDisabledDate(item), isTodaysDate: isTodaysDate(item), onMouseDown: function (e) { return handleDayClick(e, item); }, onPointerEnter: function () { return handlePointerEnter(item); }, disableClick: isDisabledDate(item) },
                                    react_1.default.createElement(Typo_1.SANS_3, null, item.getDate())));
                            }
                        }
                        else {
                            return (react_1.default.createElement(styled_1.StyledDateBlock, { isDisabledDate: true, key: i, invert: invert, isSelectedDate: isSelectedDate(item), onMouseDown: function (e) { return handleDayClick(e, item); }, disableClick: isDisabledDate(item) },
                                react_1.default.createElement(Typo_1.SANS_3, null, item.getDate())));
                        }
                    }), (_b = calender === null || calender === void 0 ? void 0 : calender.days) === null || _b === void 0 ? void 0 :
                    _b.map(function (item, i) {
                        if (from) {
                            if (item < from) {
                                // Render days before 'from' as disabled
                                return (react_1.default.createElement(styled_1.StyledDateBlock, { key: i, invert: invert, isDisabledDate: true, disableClick: isDisabledDate(item) },
                                    react_1.default.createElement(Typo_1.SANS_3, null, item.getDate())));
                            }
                            else if (item > from && item < range) {
                                // Render days within the selected range
                                return (react_1.default.createElement(styled_1.StyledDateBlock, { key: i, range: true, isTodaysDate: isTodaysDate(item), invert: invert, onMouseDown: function (e) { return handleDayClick(e, item); }, onPointerEnter: function () { return handlePointerEnter(item); }, disableClick: isDisabledDate(item) },
                                    react_1.default.createElement(Typo_1.SANS_3, null, item.getDate())));
                            }
                            else {
                                // Render days in the current month
                                // Check if the current day is 'today' or falls in the range of previousDateOnly or futureDateOnly
                                // and apply appropriate class name for styling
                                return (react_1.default.createElement(styled_1.StyledDateBlock, { key: i, invert: invert, isSelectedDate: isSelectedDate(item) || isEqualDate(from, item), isDisabledDate: isDisabledDate(item), isTodaysDate: isTodaysDate(item), onMouseDown: function (e) { return handleDayClick(e, item); }, onPointerEnter: function () { return handlePointerEnter(item); }, disableClick: isDisabledDate(item) },
                                    react_1.default.createElement(Typo_1.SANS_3, null, item.getDate())));
                            }
                        }
                        else {
                            // Render days in the current month
                            // Check if the current day is 'today' or falls in the range of previousDateOnly or futureDateOnly
                            // and apply appropriate class name for styling
                            return (react_1.default.createElement(styled_1.StyledDateBlock, { key: i, isSelectedDate: isSelectedDate(item), isTodaysDate: isTodaysDate(item), isDisabledDate: isDisabledDate(item), disableClick: isDisabledDate(item), invert: invert, onMouseDown: function (e) { return handleDayClick(e, item); } },
                                react_1.default.createElement(Typo_1.SANS_3, null, item.getDate())));
                        }
                    }), (_c = calender === null || calender === void 0 ? void 0 : calender.nextDays) === null || _c === void 0 ? void 0 :
                    _c.map(function (item, i) {
                        if (from) {
                            if (item > from && item < range) {
                                // Render days within the selected range
                                return (react_1.default.createElement(styled_1.StyledDateBlock, { key: i, invert: invert, range: true, onMouseDown: function (e) { return handleDayClick(e, item); }, onPointerEnter: function () { return handlePointerEnter(item); }, disableClick: isDisabledDate(item) },
                                    react_1.default.createElement(Typo_1.SANS_3, null, item.getDate())));
                            }
                            else if (item < from) {
                                // Render disabled days before 'from'
                                return (react_1.default.createElement(styled_1.StyledDateBlock, { key: i, 
                                    // className="disabled-date"
                                    invert: invert, isDisabledDate: true, disableClick: isDisabledDate(item) },
                                    react_1.default.createElement(Typo_1.SANS_3, null, item.getDate())));
                            }
                            else {
                                // Render days in the next month
                                // Check if the current day is 'today' or falls in the range of previousDateOnly or futureDateOnly
                                // and apply appropriate class name for styling
                                return (react_1.default.createElement(styled_1.StyledDateBlock, { key: i, invert: invert, isSelectedDate: isSelectedDate(item) || isEqualDate(from, item), isDisabledDate: isDisabledDate(item), disableClick: isDisabledDate(item), isTodaysDate: isTodaysDate(item), onMouseDown: function (e) { return handleDayClick(e, item); }, onPointerEnter: function () { return handlePointerEnter(item); } },
                                    react_1.default.createElement(Typo_1.SANS_3, null, item.getDate())));
                            }
                        }
                        else {
                            // Render days in the next month as disabled if 'from' is not defined
                            return (react_1.default.createElement(styled_1.StyledDateBlock, { key: i, invert: invert, isSelectedDate: isSelectedDate(item), isDisabledDate: true, disableClick: isDisabledDate(item), onMouseDown: function (e) { return handleDayClick(e, item); } },
                                react_1.default.createElement(Typo_1.SANS_3, null, item.getDate())));
                        }
                    })))));
    };
    return (react_1.default.createElement("div", { style: { display: "flex", flexDirection: "column" } },
        react_1.default.createElement(BlockLabel_1.BlockLabel, __assign({}, (0, _EXPORTS_1.getBlockLabelProps)(props))),
        react_1.default.createElement(styled_1.StyledDateInputContainer, { invert: invert, onClick: function () { return setShowCalendar(true); }, ref: containerRef },
            readOnly ? (react_1.default.createElement(Typo_1.SANS_3, null, getReadOnlyDate())) : (react_1.default.createElement(styled_1.StyledDateInputWrapper, null,
                react_1.default.createElement(styled_1.StyledInput, { ref: inputRef, type: "text", className: "SANS_3", invert: invert, disabled: disabled, onChange: handleOnChange, placeholder: "DD/MM/YYYY", maxLength: "10", onKeyDown: handleKeyDown, onBlur: handleFocusOut, onFocus: function () {
                        (0, handlePos_1.handleVerticalPos)(calenderRef, inputRef);
                    } }))),
            screenWidth > (0, mixins_1.getBreakPoint)('sm') ?
                genCalenderContainer()
                :
                    showCalendar ? react_1.default.createElement(Modal_1.Modal, { onClose: function () { return setShowCalendar(false); }, overflowVisible: false, fitToContentHeight: true, title: "Select Date" }, genCalenderContainer()) : null)));
}
exports.default = react_1.default.memo(DatePicker);
